import { Organization } from '../types';
import { useAppState } from './index';

export const useOrganizationExperienceMode = (): {
    isUphealOS: boolean;
    organization: Organization | undefined;
} => {
    const { organizations } = useAppState();
    const organization = organizations?.at(0);
    const isUphealOS = organization?.isUphealOS ?? false;

    return { isUphealOS, organization };
};
